import {mainAPI} from 'root/angular-injector-provider';

export function saveAsCsvFile(filename = 'filename', header = [], data =[]) {
  return mainAPI().server.asCsvFileDownload(filename, header, data);
}
